/*eslint-disable*/
import React from "react";


// components
import {
  Chip,
} from "@mui/material";
import CircleIcon from '@mui/icons-material/Circle';
// constants


//styles


const SuccessBadge = () => (<Chip icon={<CircleIcon style={{ fontSize: "small" }} />} label="Success" variant="outlined" style={{ backgroundColor: "#53CE76", color: "#FFF" }} />)

const InProgressBadge = () => (<Chip icon={<CircleIcon style={{ fontSize: "small", color: "#004685" }} />} label="InProgress" variant="outlined" style={{ backgroundColor: "#69D0FF", color: "#004685" }} />)

const PartialProgressBadge = () => (<Chip icon={<CircleIcon style={{ fontSize: "small", color: "#EB1700" }} />} label="InProgress" variant="outlined" style={{ color: "#EB1700" }} />)


const FailedBadge = () => (<Chip icon={<CircleIcon style={{ fontSize: "small", color: "#EB1700" }} />} label="Failed" variant="outlined" style={{ color: "#EB1700" }} />)


function StatusBadge({ status }) {

  if (status === "processed" || status === "completed") {
    return <SuccessBadge />
  }
  if (status === "partial-processed") {
    return <PartialProgressBadge />
  }
  if (status === "failed" || status === "failed-validation") {
    return <FailedBadge />
  }
  return (
    <InProgressBadge />
  );
}

export default StatusBadge;
